module.exports = __webpack_public_path__ + "static/media/person.777a978f.png";